export default "__VITE_ASSET__ChNOxtsY__"